import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import AuthStateApp from './App'

ReactDOM.render(
  <React.StrictMode>
    <AuthStateApp />
  </React.StrictMode>,
  document.getElementById('root')
)
